// @flow
import { Button } from "../common";
import { Wrapper } from "./Notification.styles";
import React from "react";

const Success = ({ message, onClose }: Props) => {
	return (
		<Wrapper color={"#000"}>
			<h2>{message}</h2>
			<Button onClick={() => onClose()} gradient={"default"}>
				Entendido
			</Button>
		</Wrapper>
	);
};

export default Success;
